import { render } from "./UpcomingBirthday.vue?vue&type=template&id=557376de&scoped=true"
import script from "./UpcomingBirthday.vue?vue&type=script&lang=js"
export * from "./UpcomingBirthday.vue?vue&type=script&lang=js"

import "./upcoming-birthday.scss?vue&type=style&index=0&id=557376de&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557376de"]])

export default __exports__